
export enum CountryCode {
  US = 'US',
  CN = 'CN',
  JP = 'JP',
  UK = 'UK',
  DE = 'DE',
  FR = 'FR',
  KR = 'KR',
  RU = 'RU'
}

export interface CreditCard {
  number: string;
  expiry: string;
  cvv: string;
  type: string;
}

export interface Identity {
  id: string;
  name: string;
  gender: '男' | '女';
  birthday: string;
  age: number;
  idNumber: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: CountryCode | string;
  };
  phone: string;
  email: string;
  job: string;
  company: string;
  creditCard: CreditCard;
  bio: string;
  timestamp: number;
}

export interface LoginLog {
  id: number;
  username: string;
  ip: string;
  user_agent: string;
  browser: string;
  os: string;
  device_type: 'pc' | 'mobile' | 'tablet' | 'unknown';
  fingerprint: string;
  location: string; // 新增：地理位置 (e.g. "Shanghai, CN")
  timestamp: number;
}

export interface User {
  username: string;
  email: string;
  role: 'admin' | 'user';
  quota: number;
  used_quota: number;
  is_verified: boolean;
  register_ip?: string;
  register_fingerprint?: string;
  last_login_ip?: string;
  last_login_device?: string;
  last_login_fingerprint?: string;
  createdAt: number;
}

export interface GenerationConfig {
  country: CountryCode | string;
  gender?: '男' | '女' | '随机';
  minAge: number;
  maxAge: number;
  city?: string;
  state?: string;
  model: 'gemini-3-flash-preview' | 'gemini-3-pro-preview';
}

export interface MockEmail {
  id: string | number;
  subject: string;
  recipient: string;
  content: string;
  timestamp: number;
}
